import styled from "styled-components";
import { palette } from "styled-theme";

const SummaryWrapper = styled.div`
  display: flex;
  height: 145px;
  .attributes {
    @media (max-width: 1100px) {
      display: none;
    }
    /* margin: 10px 20px 0px 0px; */
    padding: 10px 20px 0 20px;
    border-right: 1px solid ${palette("border", 0)};
    align-self: flex-start;
    .label {
      padding: 0 !important;
    }
  }
`;

export default SummaryWrapper;
